import React, { useState } from 'react';
import { Plus, Edit2, Trash2, UserCheck } from 'lucide-react';

export default function SalesmanMaster() {
  const [data, setData] = useState([
    { id: 1, code: 'ABEESH CA', name: 'ABEESH CA', target: '0.000', locn: '', dept: 'HEAD OFFICE', passkey: '' },
    { id: 2, code: 'BIJU', name: 'BIJU', target: '0.000', locn: 'A', dept: 'HEAD OFFICE', passkey: '' }
  ]);

  const [form, setForm] = useState({ code: '', name: '', target: '', dept: 'HEAD OFFICE', locn: '', passkey: '' });
  const [selectedId, setSelectedId] = useState(null);

  const clearForm = () => { setForm({ code: '', name: '', target: '', dept: 'HEAD OFFICE', locn: '', passkey: '' }); setSelectedId(null); };

  return (
    <div className="w-full max-w-5xl bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div className="bg-slate-50 border-b border-slate-200 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg"><UserCheck size={20} /></div>
          <div>
            <h2 className="text-lg font-semibold text-slate-800">Salesperson</h2>
          </div>
        </div>
      </div>

      <div className="p-6 border-b border-slate-100 bg-slate-50/50 flex flex-col gap-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-slate-600">Salesperson Code</label>
            <input type="text" value={form.code} onChange={e => setForm({...form, code: e.target.value})} className="w-full bg-white text-slate-800 px-3 py-2 text-sm rounded-lg border border-slate-200 focus:indigo-500 outline-none" />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-slate-600">Target</label>
            <input type="text" value={form.target} onChange={e => setForm({...form, target: e.target.value})} className="w-full bg-white text-slate-800 px-3 py-2 text-sm rounded-lg border border-slate-200 focus:indigo-500 outline-none" />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-slate-600">Sales Person Name</label>
            <input type="text" value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full bg-white text-slate-800 px-3 py-2 text-sm rounded-lg border border-slate-200 focus:indigo-500 outline-none" />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-slate-600">Department</label>
            <select value={form.dept} onChange={e => setForm({...form, dept: e.target.value})} className="w-full bg-white text-slate-800 px-3 py-2 text-sm rounded-lg border border-slate-200 outline-none">
              <option value="HEAD OFFICE">HEAD OFFICE</option>
              <option value="BRANCH A">BRANCH A</option>
            </select>
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-slate-600">Location</label>
            <select value={form.locn} onChange={e => setForm({...form, locn: e.target.value})} className="w-full bg-white text-slate-800 px-3 py-2 text-sm rounded-lg border border-slate-200 outline-none">
              <option value=""></option>
              <option value="A">A</option>
              <option value="B">B</option>
            </select>
          </div>

          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-slate-600">Pass key</label>
            <input type="text" value={form.passkey} onChange={e => setForm({...form, passkey: e.target.value})} className="w-full bg-white text-slate-800 px-3 py-2 text-sm rounded-lg border border-slate-200 focus:indigo-500 outline-none" />
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-2 border-t border-slate-100 w-full">
          <button onClick={() => { setData([...data, { id: Date.now(), ...form }]); clearForm(); }} disabled={!!selectedId} className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-slate-200 text-white font-medium text-sm py-2 px-5 rounded-lg transition-colors"><Plus size={16} /><span>Add Rep</span></button>
          <button onClick={() => { setData(data.map(d => d.id === selectedId ? { ...d, ...form } : d)); clearForm(); }} disabled={!selectedId} className="flex items-center gap-2 bg-slate-800 hover:bg-slate-900 disabled:bg-slate-100 text-white font-medium text-sm py-2 px-5 rounded-lg transition-colors"><Edit2 size={16} /><span>Save</span></button>
          <button onClick={() => { setData(data.filter(d => d.id !== selectedId)); clearForm(); }} disabled={!selectedId} className="flex items-center gap-2 bg-rose-50 text-rose-600 hover:bg-rose-100 disabled:bg-slate-100 font-medium text-sm py-2 px-5 rounded-lg transition-colors"><Trash2 size={16} /><span>Remove</span></button>
          {selectedId && <button onClick={clearForm} className="text-xs text-slate-500 hover:text-slate-800 underline px-2 self-center">Cancel</button>}
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-slate-500 font-medium bg-slate-50/50">
              {['Salesperson ID', 'Full Corporate Name', 'Target Volume', 'Location'].map((col, i) => <th key={i} className="px-6 py-3 font-medium text-xs uppercase text-slate-400">{col}</th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 text-slate-700">
            {data.map(item => (
              <tr key={item.id} onClick={() => { setSelectedId(item.id); setForm({...item}); }} className={`cursor-pointer transition-colors ${selectedId === item.id ? 'bg-indigo-50/70 text-indigo-900 font-medium' : 'hover:bg-slate-50'}`}>
                <td className="px-6 py-3.5 font-semibold text-slate-900">{item.code}</td>
                <td className="px-6 py-3.5 text-slate-600">{item.name}</td>
                <td className="px-6 py-3.5 text-slate-500">{item.target}</td>
                <td className="px-6 py-3.5">{item.locn ? <span className="inline-block bg-slate-100 text-slate-700 text-xs font-bold px-2 py-0.5 rounded">{item.locn}</span> : <span className="text-slate-300 italic">Global</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}